// SET_TEXT_FILTER
export const setTextFilter = (text = "") => ({
  type: "SET_TEXT_FILTER",
  text
});

// SET_GROUP_FILTER
export const setGroupFilter = (group = []) => ({
  type: "SET_GROUP_FILTER",
  group
});
